
















import { Component, Prop, Vue } from 'vue-property-decorator';

import { PREVIOUS_RETAILER_COOKIE } from '../services/PreviousRetailerCookie';

/**
 * Shown in the central site header. The server reads the cookie saved by RememberRetailerVisited
 * and passes the store info (name, phone, hours, url).
 */
const HIDDEN_KEY = `${PREVIOUS_RETAILER_COOKIE}_hidden`;

@Component
class DisplayPreviousRetailerVisited extends Vue {
    @Prop({ default: '' }) public name!: string;
    @Prop({ default: '' }) public phone!: string;
    @Prop({ default: '' }) public openingHours!: string;
    @Prop({ default: '' }) public url!: string;

    public show: boolean = false;

    get details(): string {
        return [this.phone, this.openingHours].filter(Boolean).join(' · ');
    }

    private hasRetailerCookie(): boolean {
        return document.cookie
            .split(';')
            .map(c => c.trim())
            .some(c => c.startsWith(`${PREVIOUS_RETAILER_COOKIE}=`) && c.length > PREVIOUS_RETAILER_COOKIE.length + 1);
    }

    private isHidden(): boolean {
        try {
            return sessionStorage.getItem(HIDDEN_KEY) === 'hidden';
        } catch {
            return false;
        }
    }

    mounted() {
        this.show = !!this.name && this.hasRetailerCookie() && !this.isHidden();
    }

    public clearThisSession() {
        try {
            sessionStorage.setItem(HIDDEN_KEY, 'hidden');
        } catch {}
        this.show = false;
    }

    public clearSavedRetailer() {
        document.cookie = `${PREVIOUS_RETAILER_COOKIE}=; max-age=0; path=/`;
        try {
            sessionStorage.removeItem(HIDDEN_KEY);
        } catch {}
        this.show = false;
    }
}

export default DisplayPreviousRetailerVisited;

